<svg class="diag-graphe-v2-consommation" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 330 260">
    <defs>
        <style>
            .diag-graphe-v2-consommation .a {
                fill: #00a06d;
            }

            .diag-graphe-v2-consommation .b {
                fill: #52b153;
            }

            .diag-graphe-v2-consommation .c {
                fill: #a5cc74;
            }

            .diag-graphe-v2-consommation .d {
                fill: #f4e70f;
            }

            .diag-graphe-v2-consommation .e {
                fill: #f0b40f;
            }

            .diag-graphe-v2-consommation .f {
                fill: #eb8235;
            }

            .diag-graphe-v2-consommation .g {
                fill: #d7221f;
            }

            .diag-graphe-v2-consommation .line-black {
                fill: none;
                stroke: #1d1d1b;
                stroke-width: 1.42px;
            }

            .diag-graphe-v2-consommation .passoire {
                fill: none;
                stroke: #9d9d9c;
                stroke-width: 1.5px;
            }

            .diag-graphe-v2-consommation .value {
                fill: #1d1d1b;
            }

            .diag-graphe-v2-consommation .white {
                fill: #fff;
            }
        </style>
    </defs>

    <title>Performance énergétique</title>

    <!-- A -->
    <text x="110" y="18" class="a" font-size="8" font-weight="bold">logement extrêmement performant</text>
    <polygon class="a" points="156.72 45.69 110.73 45.69 110.73 22.22 156.72 22.22 164.67 33.96 156.72 45.69"/>
    <path class="white" d="M126.52,41.21l-1-3.32h-4.66l-1,3.32h-3.08l4.6-14h3.76l4.54,14ZM123.22,30h-.1l-1.54,5.3h3.2Z"/>

    <!-- B -->
    <polygon class="b" points="175.11 72.37 110.73 72.37 110.73 48.9 175.11 48.9 183.06 60.64 175.11 72.37"/>
    <path class="white"
          d="M118.1,53.93h6.78a3.38,3.38,0,0,1,3.68,3.58c0,2.14-1.18,2.94-2.6,3v.12a3.09,3.09,0,0,1,3.14,3.28,3.76,3.76,0,0,1-3.6,4h-7.4Zm3,5.72h3a1.18,1.18,0,0,0,1.28-1.28v-.6a1.18,1.18,0,0,0-1.28-1.28h-3Zm0,5.68h3.5a1.18,1.18,0,0,0,1.3-1.26v-.68a1.18,1.18,0,0,0-1.3-1.26h-3.5Z"/>

    <!-- C -->
    <polygon class="c" points="193.36 99.06 110.73 99.06 110.73 75.58 193.36 75.58 201.3 87.32 193.36 99.06"/>
    <path class="white"
          d="M117.72,87.21c0-4.72,2.42-7.32,6.18-7.32a5.17,5.17,0,0,1,5.22,3.28l-2.62,1.36a2.47,2.47,0,0,0-2.6-1.94c-1.78,0-3,1.2-3,3.4v2.24c0,2.2,1.18,3.4,3,3.4a2.87,2.87,0,0,0,2.78-2.08L129.16,91a5.46,5.46,0,0,1-5.26,3.35C120.14,94.34,117.72,91.93,117.72,87.21Z"/>

    <!-- D -->
    <polygon class="d" points="211.61 125.74 110.73 125.74 110.73 102.26 211.61 102.26 219.55 114 211.61 125.74"/>
    <path class="white"
          d="M117.8,106.82h5.26c3.7,0,6.14,2.34,6.14,7s-2.44,7-6.14,7H117.8Zm5.26,11.26c1.8,0,2.92-1,2.92-3.2v-2.16c0-2.22-1.12-3.2-2.92-3.2h-2.22v8.56Z"/>

    <!-- E -->
    <polygon class="e" points="111.44 173.59 111.44 129.65 229.74 129.65 244.71 151.62 229.74 173.59 111.44 173.59"/>
    <path class="value"
          d="M229.36,130.36l14.49,21.26-14.49,21.26H112.14V130.36H229.36m.75-1.41H110.73V174.3H230.11l15.45-22.68L230.11,129Z"/>

    <!-- F -->
    <polygon class="f" points="264.2 200.98 110.73 200.98 110.73 177.5 264.2 177.5 272.14 189.24 264.2 200.98"/>
    <path class="white" d="M118.92,195.94V182h9.26v2.7H122v2.86h5.3v2.68H122v5.72Z"/>

    <!-- G -->
    <polygon class="g" points="282.52 227.66 110.73 227.66 110.73 204.19 282.52 204.19 290.57 215.92 282.52 227.66"/>
    <path class="white"
          d="M126.44,220.73h-.1c-.2,1.4-1.48,2.46-3.58,2.46-3.2,0-5.72-2.48-5.72-7.16s2.54-7.28,6.32-7.28a5.59,5.59,0,0,1,5.38,3.24l-2.48,1.42a2.89,2.89,0,0,0-2.9-2c-1.88,0-3.1,1.08-3.1,3.4v2.24c0,2.32,1.22,3.4,3.1,3.4,1.52,0,2.74-.72,2.74-2.08v-.7h-2.6v-2.54H129V223h-2.56Z"/>
    <text x="110" y="238" class="g" font-size="8" font-weight="bold">logement extrêmement peu performant</text>

    <!-- Passoire énergétique -->
    <line class="passoire" x1="106.07" y1="177.5" x2="106.07" y2="227.66"/>
    <g transform="translate(100,200)" font-size="7" font-weight="bold" fill="#9d9d9c" text-anchor="end">
        <text x="0" y="0">passoire</text>
        <text x="0" y="8">énergétique</text>
    </g>

    <!-- Lignes données -->
    <line class="line-black" x1="65.13" y1="132.84" x2="65.13" y2="170.4"/>
    <path class="value"
          d="M110.72,130.36v42.52H15.88a2.4,2.4,0,0,1-2.4-2.4V132.77a2.4,2.4,0,0,1,2.4-2.41h94.84m1.42-1.41H15.88a3.82,3.82,0,0,0-3.82,3.82v37.71a3.82,3.82,0,0,0,3.82,3.82h96.26V129Z"/>
    <path class="white"
          d="M119.23,167.09a.71.71,0,0,1-.71-.71V137.06a.7.7,0,0,1,.71-.71h20a.71.71,0,0,1,.71.71v5.67a.7.7,0,0,1-.71.7H126.32V148h10.93a.71.71,0,0,1,.71.71v5.63a.71.71,0,0,1-.71.71H126.32V160h12.86a.71.71,0,0,1,.71.71v5.67a.71.71,0,0,1-.71.71Z"/>
    <path class="value"
          d="M139.18,137.06v5.67H125.61v6h11.64v5.63H125.61v6.35h13.57v5.67h-20V137.06h20m0-1.42h-20a1.41,1.41,0,0,0-1.42,1.42v29.32a1.41,1.41,0,0,0,1.42,1.41h20a1.42,1.42,0,0,0,1.42-1.41v-5.67a1.42,1.42,0,0,0-1.42-1.42H127v-3.51h10.22a1.41,1.41,0,0,0,1.41-1.42v-5.63a1.41,1.41,0,0,0-1.41-1.41H127v-3.18h12.15a1.42,1.42,0,0,0,1.42-1.41v-5.67a1.42,1.42,0,0,0-1.42-1.42Z"/>

    <!-- Données -->
    <g *ngIf="consommation >= 0" transform="translate(40,143)" font-weight="bold" text-anchor="middle">
        <text x="0" y="5" alignment-baseline="middle" font-size="20">{{consommation}}</text>
        <text x="0" y="20" alignment-baseline="middle" font-size="7">kWh/m²/an</text>
        <text x="0" y="38" alignment-baseline="middle" font-size="7">consommation</text>
        <text x="0" y="48" alignment-baseline="middle" font-size="7" fill="#9d9d9c" font-weight="normal">
            (énergie primaire)
        </text>
    </g>

    <!-- Données -->
    <g *ngIf="emissions >= 0" transform="translate(88,143)" font-weight="bold" text-anchor="middle">
        <text x="0" y="5" alignment-baseline="middle" font-size="20">{{emissions}}</text>
        <text x="0" y="20" alignment-baseline="middle" font-size="7">
            kg CO<tspan dy="5">²</tspan><tspan dy="-3.5px">/m²/an</tspan>
        </text>
        <text x="0" y="38" alignment-baseline="middle" font-size="7">émissions</text>
    </g>
</svg>
